import {
  FETCH_USER_VOLUME_24H,
  FETCH_USER_VOLUME_24H_FAILED,
  FETCH_USER_VOLUME_24H_SUCCEED,
  FETCH_WITHDRAWAL_HISTORY,
  FETCH_WITHDRAWAL_HISTORY_FAILED,
  FETCH_WITHDRAWAL_HISTORY_SUCCEED,
  WITHDRAWAL,
  WITHDRAWAL_CUSTOM,
  WITHDRAWAL_CUSTOM_FAILED,
  WITHDRAWAL_CUSTOM_SUCCEED,
  WITHDRAWAL_FAILED,
  WITHDRAWAL_SUCCEED,
} from './action_types';
import { VERIFY_WITHDRAWAL, VERIFY_WITHDRAWAL_FAILED, VERIFY_WITHDRAWAL_SUCCEED } from '../login/action_types';

export default {
  onWithdrawal: (data, callback) => ({
    type: WITHDRAWAL,
    params: {
      data,
    },
    callback,
  }),
  onWithdrawalFailed: (err) => ({
    type: WITHDRAWAL_FAILED,
    err,
  }),
  onWithdrawalSucceed: (data) => ({
    type: WITHDRAWAL_SUCCEED,
    params: {
      data,
    },
  }),

  onWithdrawalCustom: (data, callback) => ({
    type: WITHDRAWAL_CUSTOM,
    params: {
      data,
    },
    callback,
  }),
  onWithdrawalCustomFailed: (err) => ({
    type: WITHDRAWAL_CUSTOM_FAILED,
    err,
  }),
  onWithdrawalCustomSucceed: (data) => ({
    type: WITHDRAWAL_CUSTOM_SUCCEED,
    params: {
      data,
    },
  }),

  onFetchTransactionHistory: (data) => ({
    type: FETCH_WITHDRAWAL_HISTORY,
    params: {
      data,
    },
  }),
  onFetchTransactionHistorySucceed: (data, totalCount) => ({
    type: FETCH_WITHDRAWAL_HISTORY_SUCCEED,
    params: {
      data,
      totalCount,
    },
  }),
  onFetchTransactionHistoryFailed: (err) => ({
    type: FETCH_WITHDRAWAL_HISTORY_FAILED,
    err,
  }),
  verifyWithdrawal: (data) => ({
    type: VERIFY_WITHDRAWAL,
    params: {
      data,
    },
  }),
  verifyWithdrawalSucceed: (data) => ({
    type: VERIFY_WITHDRAWAL_SUCCEED,
    params: {
      data,
    },
  }),
  verifyWithdrawalFailed: (err) => ({
    type: VERIFY_WITHDRAWAL_FAILED,
    err,
  }),

  fetchUserVolume24hAction: (data, forceFetch) => ({
    type: FETCH_USER_VOLUME_24H,
    params: {
      data,
      forceFetch,
    },
  }),
  fetchUserVolume24hActionSucceed: (data) => ({
    type: FETCH_USER_VOLUME_24H_SUCCEED,
    params: {
      data,
    },
  }),
  fetchUserVolume24hActionFailed: (err) => ({
    type: FETCH_USER_VOLUME_24H_FAILED,
    err,
  }),
};
